import { Button, DialogActions } from "@mui/material"

// others
import { yupResolver } from "@hookform/resolvers/yup"
import { CategoryFormValues } from "../../../interfaceTypes/forms"
import { CategoryModalProps } from "../../../interfaceTypes/props"
import { FormProvider, useForm } from "react-hook-form"
import { addCategoryValidationSchema } from "../../../validationSchema"
import { useCreateCategoryMutation, useUpdateCategoryMutation } from "../../../../generated"

// components
import { CustomController } from "../../common/CustomController"
import { CustomModal } from "../../common/CustomModal"
import { Alert } from "../../common/Alert"

const CategoryModal = ({ isOpen, category, handleClose, refetch }: CategoryModalProps) => {
  const methods = useForm<CategoryFormValues>({
    resolver: yupResolver(addCategoryValidationSchema),
    mode: 'onChange',
    defaultValues: {
      name: category?.name || '',
      description: category?.description || ''
    }
  })

  const { handleSubmit, reset } = methods

  const [ createCategory ] = useCreateCategoryMutation({
      onError: error => {
        Alert.error(error.message)
      },
      onCompleted: data => {
        reset()
        refetch()
        handleClose?.()
        if (data) Alert.success('Category created successfully!')
      }
  })
  
  const [ updateCategory ] = useUpdateCategoryMutation({
      onError: error => {
        Alert.error(error.message)
      },
      onCompleted: data => {
        reset()
        refetch()
        handleClose?.()
        if (data) Alert.success('Category updated!')
      }
  })

  const onSubmit = async (data: CategoryFormValues) => {
    console.log('categoryData', data)
    category?.id ? 
      await updateCategory({ 
        variables: { 
          updateCategoryInput: { 
            id: category.id, 
            ...data 
          } 
        } 
      }) :
      await createCategory({
        variables: {
          createCategoryInput: {
            ...data
          }
        }
      })
  }

  const closeModal = () => {
    reset()
    handleClose?.()
  }

  return (
    <CustomModal isOpen={isOpen ?? false} title={category?.id ? 'Edit Category' : 'Add Category'} handleClose={closeModal} >
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} style={{ display: 'grid', gap: 20}}>    
          <CustomController controllerLabel="Name" controllerName="name" fieldType="text" defaultValue="256" required />
        
          <CustomController controllerLabel="Notes" controllerName="description" fieldType="text" />

          <DialogActions>
            <Button variant="text" onClick={handleClose} sx={{ color: 'gray' }}>
              Cancel
            </Button>
          
            <Button type="submit" variant="contained" >
              {category?.id ? 'Save' : 'Add'}
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </CustomModal>
  )
}

export default CategoryModal